import { ITeamPlayersTable, TeamPlayersTable } from '@sky-it-livedata/livedata-sports-design-system';

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { TeamPlayersQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<TeamPlayersQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<TeamPlayersQuery>): ITeamPlayersTable => {
  return transformer(props);
}

const TeamPlayers = ({
  props,
  ...rest
}: WidgetContext<ITeamPlayersTable>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <TeamPlayersTable {...props} />
    </div>
  );
}

export default TeamPlayers;